@if (infotext) {
    <p-panel [header]="'de.his.javang.infos' | hisUi">
        <div [innerHTML]="infotext"></div>
    </p-panel>
    <div class="spaceAboveHalfEm"></div>
}
<p-panel
    [header]="'cs.psv.problemcase.ProblemCase.userdataFieldsetHeader' | hisUi"
>
    <his-plam>
        <p-autoComplete
            #content
            hisDdKey="cs.psv.problemcase.ProblemCase.senderEmailId"
            [title]="'cs.psv.problemcase.ProblemCase.senderEmailId' | hisUi"
            [dropdown]="true"
            [forceSelection]="true"
            [suggestions]="filteredSenders"
            (completeMethod)="filterSender($event)"
            [required]="true"
            [(ngModel)]="pcSenderEmail"
            [disabled]="disabled"
        >
        </p-autoComplete>
    </his-plam>

    @if (recipientsVisible) {
        @if (recipientsEditable && !disabled) {
            <his-multiselect-plam
                ddKey="cs.psv.problemcase.ProblemCase.recipientIds"
                [label]="'cs.psv.problemcase.ProblemCase.recipientIds' | hisUi"
                [customOptionsMethod]="getRecipientOptions()"
                [removeSelectedOptionsFromDropdown]="true"
                [showDeleteButton]="true"
                [showSelectButton]="true"
                [selectedOptions]="pcSelectedRecipients"
                (selectedOptionsChange)="onSelectedRecipientsChange($event)"
                field="text"
            >
            </his-multiselect-plam>
        } @else {
            <his-plam
                [label]="'cs.psv.problemcase.ProblemCase.recipientIds' | hisUi"
                [required]="true"
                hisDdKey="cs.psv.problemcase.ProblemCase.recipientIds"
            >
                <ul #content>
                    @for (
                        recipient of pcSelectedRecipients;
                        track recipient.id
                    ) {
                        <li>{{ recipient.label }}</li>
                    }
                </ul>
            </his-plam>
        }
    }

    @if (subjectVisible) {
        <his-plam>
            <input
                #content
                pInputText
                hisDdKey="cs.psv.problemcase.ProblemCase.subject"
                class="inputWidth100"
                [required]="true"
                [(ngModel)]="pcSubject"
                [disabled]="disabled"
            />
        </his-plam>
    }

    <his-plam>
        <textarea
            #content
            pInputTextarea
            hisDdKey="cs.psv.problemcase.ProblemCase.content"
            class="textareaWidth100"
            rows="10"
            [required]="true"
            [(ngModel)]="pcContent"
            [disabled]="disabled"
        >
        </textarea>
    </his-plam>
</p-panel>

@if (contextInformation?.data?.length > 0) {
    <div class="spaceAboveHalfEm"></div>
    <p-panel
        [header]="'cs.psv.problemcase.ProblemCase.contextInformation' | hisUi"
    >
        <div
            [innerHTML]="
                'cs.psv.problemcase.ProblemCase.contextInformation.helptext'
                    | hisUi
            "
        ></div>
        <div class="spaceAboveHalfEm"></div>
        <p-table [value]="contextInformation.data">
            <ng-template pTemplate="header">
                <tr>
                    @for (header of contextInformation.headers; track $index) {
                        <th>{{ header | hisUi }}</th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    @for (item of row; track $index) {
                        <td>{{ item }}</td>
                    }
                </tr>
            </ng-template>
        </p-table>
    </p-panel>
}

<div class="consentDataProcessingContainer">
    <his-plam
        class="leftAlignedCheckbox"
        [label]="'cs.psv.problemcase.notice.consentDataProcessing' | hisUi"
    >
        <input
            type="checkbox"
            #content
            [required]="true"
            [(ngModel)]="consentDataProcessing"
            [disabled]="disabled"
        />
    </his-plam>
</div>

<button
    type="button"
    (click)="onSubmitProblemCase()"
    [disabled]="!consentDataProcessing || disabled"
    class="submit_highlighted"
>
    {{ "cs.psv.problemcase.action.send" | hisUi }}
</button>
@if (showCancelButton) {
    <button type="button" (click)="onCancelProblemCase()" [disabled]="disabled">
        {{ "cs.psv.problemcase.action.cancel" | hisUi }}
    </button>
}
